// ** Feature Imports
import { SubscriptionOptions } from '@/features/subscriptions'

// ** Styled Components
import { Button } from '@/shared/ui'
import { ChoosePlanWrapper, StyledHeading, StyledTypography } from './styles'

// ** Third Party Imports
import { Navigate, useNavigate } from 'react-router-dom'

// ** Entity Imports
import { useGetMyPlanQuery } from '@/entities/custom-pricing'
import { useLogoutMutation } from '@/entities/session'
import { useGetCurrentUserQuery } from '@/entities/user'

// ** Feature Imports
import { LogoutIcon } from '@/features/auth/logout/ui/styles'
import { Skip } from '@/shared/ui/icons'
import { Title } from '@/widgets/CreateNewWidget/styles'
import styled from 'styled-components'

const SkipIcon = styled(Skip)`
	& path {
		stroke: #fafafa;
	}
`

export const ChoosePlanPage = () => {
	const { data: currentUser } = useGetCurrentUserQuery(undefined, {
		pollingInterval: 0,
		refetchOnMountOrArgChange: true,
		refetchOnReconnect: true,
		skip: false
	})
	const { data: myPlan } = useGetMyPlanQuery()
	const [logout] = useLogoutMutation()
	const navigate = useNavigate()
	const isCustom = myPlan?.isCustom === true

	if (currentUser?.activeSubscription) {
		return <Navigate to='/' replace />
	}

	const handleSkip = async () => {
		navigate('/', { replace: true })
	}

	return (
		<>
			{currentUser?.role?.name === 'Owner' ? (
				<ChoosePlanWrapper>
					{/* <Button
						label='Logout'
						className='logout'
						startIcon={<LogoutIcon style={{ transform: 'scaleX(-1)' }} />}
						variant='text'
						onClick={() => {
							logout()
						}}
					/> */}
					<Button
						label='Skip'
						className='logout'
						startIcon={<SkipIcon style={{ transform: 'scaleX(-1)' }} />}
						variant='text'
						onClick={() => {
							handleSkip()
						}}
					/>

					<StyledHeading variant='h2' weight='bold'>
						{isCustom ? 'Your negotiated plan' : 'Choose a Plan to Continue'}
					</StyledHeading>
					<StyledTypography>
						{isCustom
							? 'These are the terms agreed for your organization. Subscribe to activate them — no access is granted without an active subscription.'
							: "To access FortunAI's features, you'll need to select a plan that fits your business. Pick the one that works best for you — no access is granted without an active subscription."}
					</StyledTypography>
					<SubscriptionOptions />
				</ChoosePlanWrapper>
			) : (
				<ChoosePlanWrapper style={{ maxWidth: '500px' }}>
					<Title
						variant='h2'
						weight='semi-bold'
						style={{ textAlign: 'center', marginBottom: 0 }}
					>
						Subscription Required
					</Title>
					<StyledTypography weight='medium'>
						You cannot access the application because your organization&apos;s
						subscription is inactive or has expired. Only the organization owner
						can manage subscription details. To resolve this subscription issue
						contact the owner.
					</StyledTypography>

					<Button
						label='Log out'
						className='logout'
						startIcon={<LogoutIcon style={{ transform: 'scaleX(-1)' }} />}
						style={{ width: '100%' }}
						variant='primary'
						fullWidth
						onClick={() => {
							logout()
						}}
					/>
				</ChoosePlanWrapper>
			)}
		</>
	)
}
